import { PrimaryCta, SecondaryCta, Seo } from '@/components/primitives'

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found | TLDNXS"
        description="The page you requested does not exist."
      />
      <section
        aria-labelledby="notfound-title"
        className="relative flex min-h-[60vh] items-center overflow-hidden"
      >
        <div
          aria-hidden="true"
          className="field-grid pointer-events-none absolute inset-0 opacity-50 [mask-image:radial-gradient(70%_60%_at_50%_40%,black,transparent)]"
        />
        <div className="text-center relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8">
          <p className="eyebrow-mute">404</p>
          <h1
            id="notfound-title"
            className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl"
          >
            Page not found.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-ink-mute md:text-lg">
            This page does not exist. The rest of the site is one click away.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <PrimaryCta to="/">Back to the homepage</PrimaryCta>
            <SecondaryCta to="/walkthrough">Book a walkthrough</SecondaryCta>
          </div>
        </div>
      </section>
    </>
  )
}
